export default __webpack_public_path__ + "static/media/LectureHall.dfebd155.png";